import { formatCurrencyDecimal } from '@epi-helpers/numeral';
import React from 'react';
import { Checkbox } from 'edenred-ui';

import { EstimationDetailsRowProps } from '@epi-models/components/EstimationDetails';

import { CalculatorRow, CrossedOutAmount } from './EstimationDetails.styles';

const EstimationDetails = ({
  amount,
  message = null,
  hideIfZero = false,
  toggable = false,
  checked = false,
  setChecked = () => {},
  id = '',
  monthId,
  month,
  mergedColumns = false
}: EstimationDetailsRowProps) => {
  if (amount <= 0 && hideIfZero) {
    return null;
  }
  const dataTestSuffix = monthId ? `-${monthId}` : '';
  return (
    <CalculatorRow $mergedColumns={mergedColumns}>
      <div id={`estimation-details-row-text-${id}`}>
        {toggable && (
          <Checkbox
            inputProps={
              {
                'data-testid': `${monthId}-checkbox${dataTestSuffix}`
              } as React.InputHTMLAttributes<HTMLInputElement>
            }
            checked={checked}
            onChange={() => setChecked(id)}
          />
        )}
        {month}
      </div>
      <div id={`estimation-details-row-message-${id}`}>{message}</div>
      <CrossedOutAmount
        $crossedOut={toggable && !checked}
        id={`estimation-details-row-amount-${id}`}
      >
        {formatCurrencyDecimal(amount)}
      </CrossedOutAmount>
    </CalculatorRow>
  );
};

export default EstimationDetails;
